import { styled } from '@material-ui/core';
import BaseButton from '../BaseButton';

const getColourFromVariant = (variant, theme) => {
  switch (variant) {
    case 'slighter':
      return {
        colour: theme.palette.common.osloGray,
        hoverColour: theme.palette.common.nevada,
      };
    default:
      return {
        colour: theme.palette.xpl.secondary.default,
        hoverColour: theme.palette.xpl.secondary.hover,
      };
  }
};

export const TextButtonComponent = styled(BaseButton)(({ variant, theme }) => {
  const { colour, hoverColour } = getColourFromVariant(variant, theme);
  return {
    borderWidth: '0',
    minWidth: 0,
    minHeight: 0,
    padding: '0',
    color: colour,
    textDecoration: 'underline',
    backgroundColor: 'transparent',
    '&:hover': {
      color: hoverColour,
      // Helps remove sticky effect on mobile devices.
      '@media (hover: none)': {
        color: colour,
      },
    },
    '@media (hover: none)': {
      '&:focus': {
        color: hoverColour,
      },
    },
    '&:disabled': {
      opacity: '0.5',
    },
  };
});
